'use strict';

const jQuery = require('jquery');

const Translator = require('./../../../core/translator');
const pluginUploader = require('./upload');
const PopinManager = require('./../../../services/popin');
const dndZone = require('./../service/dndZone');
const ResizeColumn = require('./../service/resizeColumn');
const HighlightContent = require('./../service/highlightContent');
const imageCrop = require('../service/imageCrop');
const SaveManager = require('./../component/SaveManager');
const Help = require('./../../../services/help');
const Loader = require('./../../../services/loader');
const Plugin = require('./index');

const btnUploadTpl = require('./../template/image_upload_plugin.hbs');
const btnFocusTpl = require('./../template/image_focus_plugin.hbs');
const btnResizeTpl = require('./../template/image_resize.hbs');
const focusTpl = require('./../template/image_focus.hbs');

const minHeight = 40;

let popin;

const moveResize = function(e) {
    let imageContainer = e.data.content.$;
    let containerWidth = imageContainer.outerWidth();
    let newContainerHeight = e.data.containerHeight + e.pageY - e.data.resizeStartY;
    let ratio = newContainerHeight / containerWidth * 100;
    let $imageHeightInfo = imageContainer.find('.cloud-image-height-info');
    let $guideline = imageContainer.find('.cloud-guideline');

    if (newContainerHeight < minHeight) {
        newContainerHeight = minHeight;
        ratio = newContainerHeight / containerWidth * 100;
    }

    imageContainer.css('padding-top', ratio + '%');
    imageContainer.data('ratio', ratio);

    $imageHeightInfo.text(newContainerHeight);
    $imageHeightInfo.css('top', (newContainerHeight - $imageHeightInfo.outerHeight()) + 'px');
    $imageHeightInfo.css('left', (containerWidth / 2) + 'px');

    $guideline.css('top', newContainerHeight + 'px');

    imageCrop.applyAutoHeight(e.data.content);
    imageCrop.applyAutoWidth(e.data.content);
    imageCrop.applyWidth(e.data.content);
    imageCrop.applyPosition(e.data.content);
};

const stopResize = function(e) {
    let content = e.data.content;

    content.$.removeClass('cloud-resizing');
    content.$.find('.cloud-image-height-info').remove();
    content.$.find('.cloud-guideline').remove();

    positionBtn(content.$);
    jQuery('body').off('mousemove.resize');

    content.addParameter('ratio', content.$.data('ratio').toString());
    content.addParameter('position', content.$.data('position'));
    content.addParameter('auto_height', content.$.hasClass('image-auto-height'));
    jQuery('body').find('.main').removeAttr('style');

    SaveManager.save();
    dndZone.apply();
    ResizeColumn.apply();
};

const startResize = function(e) {
    let $content = e.data.content.$;
    let $imageHeightInfo = jQuery('<div class="cloud-image-height-info"></div>');
    let $guideline = jQuery('<div class="cloud-guideline"></div>');

    $content.addClass('cloud-resizing');

    e.data.resizeStartX = e.pageX;
    e.data.resizeStartY = e.pageY;
    e.data.containerHeight = e.data.content.$.outerHeight();
    e.data.containerWidth = e.data.content.$.outerWidth();
    e.data.image = e.data.content.$.find('img').get(0);
    e.data.imageRealHeight = e.data.image.naturalHeight;
    e.data.imageRealWidth = e.data.image.naturalWidth;
    e.data.realRatio = e.data.imageRealWidth / e.data.imageRealHeight;
    e.data.focus = e.data.content.$.data('focus') || {'top': 50, 'left': 50};

    $imageHeightInfo.text(e.data.containerHeight);
    $content.append($imageHeightInfo);
    $imageHeightInfo.css('top', ($content.outerHeight() - $imageHeightInfo.outerHeight()) + 'px');
    $imageHeightInfo.css('left', ($content.outerWidth() / 2) + 'px');

    $content.append($guideline);
    $guideline.css('top', $content.outerHeight() + 'px');
    $guideline.css('left', '-' + $content.offset().left + 'px');

    jQuery('body').on('mousemove.resize', e.data, moveResize);
    jQuery('body').one('mouseup.resize', e.data, stopResize);
    jQuery('body').find('.main').attr('style', 'overflow:  hidden');

    dndZone.destroy();
};

module.exports.onContentMouseout = function(content) {
    let $content = content.$.find('.cloud-edit-content');
    let $cloudResize = $content.find('.cloud-image-resize');
    let $moreOptions = $content.find('.cloud-image-options');

    $cloudResize.remove();
    $moreOptions.remove();
};

const positionBtn = function($content) {
    let $resizeHandler = $content.find('.cloud-image-resize');
    let contentHeight = $content.outerHeight();
    let contentWidth = $content.outerWidth();

    $resizeHandler.css('top', (contentHeight - $resizeHandler.outerHeight()) + 'px');
    $resizeHandler.css('left', (contentWidth / 2) + 'px');
};

const initFocusHandler = function(content, $imageContainer, $focusContainer) {
    let point = $imageContainer.data('focus');
    let $focusHandler = $focusContainer.find('.cloud-image-frame');
    let $focusTarget = $focusContainer.find('.cloud-image-disc');

    point.left = point.left || 50;
    point.top = point.top || 50;
    $focusTarget.css({'top': point.top + '%', 'left': point.left + '%'});

    $focusHandler.on('mousedown', {
        'content': content,
        'focusHandler': $focusHandler,
        'focusContainer': $focusContainer,
    }, startFocusMove);
};

const stopFocusMove = function(e) {
    jQuery('body').off('mousemove.focus');
    e.data.focusHandler.off('mousemove.focus');
};

const focusMove = function(e) {
    let $focusHandler = e.data.focusHandler;
    let $focusTarget = e.data.focusContainer.find('.cloud-image-disc');
    let focusCoord = {
        'top': e.offsetY * 100 / $focusHandler.outerHeight(),
        'left': e.offsetX * 100 / $focusHandler.outerWidth(),
    };
    let position = imageCrop.calculatePosition(e.data.content.$, focusCoord);

    $focusTarget.css({'top': focusCoord.top + '%', 'left': focusCoord.left + '%'});
    e.data.content.$.find('img:not(.image-picto)').css({'top': position.top + '%', 'left': position.left + '%'});
    e.data.content.$.data('focus', focusCoord);
    e.data.content.$.data('position', position);
};

const startFocusMove = function(e) {
    e.data.focusHandler.on('mousemove.focus', e.data, focusMove);
    jQuery('body').one('mouseup.focus', e.data, stopFocusMove);
};

const showForm = function(content) {
    let $imageContainer = content.$;
    let $focusContainer = jQuery(focusTpl());

    Plugin.onClick(content, true);

    $focusContainer.find('.cloud-image').html(($imageContainer.find('img:eq(0)')).clone().removeAttr('style'));
    popin = PopinManager.createPopin({
        'title': Translator.translate('focus_image'),
        'classes': {
          'ui-dialog': 'cloud-dialog prevent-click image-settings-popin',
        },
        'width': 300,
        'modal': false,
        'minHeight': 100,
        'draggable': true,
        'appendTo': '#cloud-ui',
        'position': {my: 'right top', at: 'right top'},
        'buttons': [
            {
                class: 'popin popin-cancel',
                text: Translator.translate('discard'),
                click: function() {
                    Loader.start(popin.rootElement);
                    content.refresh().done(function() {
                        Plugin.onClick(content, true);
                        popin.hide();
                    });
                },
            },
            {
                class: 'popin popin-ok',
                text: Translator.translate('submit'),
                click: function() {
                    let ratio = content.$.data('ratio');
                    let focus = content.$.data('focus');

                    content.addParameter('position', content.$.data('position'));
                    if (focus) {
                        content.addParameter('focus', focus);
                    }
                    if (ratio) {
                        content.addParameter('ratio', ratio.toString());
                    }

                    SaveManager.save();
                    popin.hide();
                },
            },
        ],
    });

    popin.setContent($focusContainer);

    popin.on('open', function() {
        cloud.disableUi();
        HighlightContent.start($imageContainer);
    });

    popin.on('close', function() {
        popin.hide();
        cloud.enableUi();
        HighlightContent.stop($imageContainer);
    });

    let $link = Help.createLink(`focus_image`);
    let $title = popin.rootElement.parent().find('.ui-dialog-titlebar:first').find('.ui-dialog-title:first');

    $title.append($link);

    popin.display();
    initFocusHandler(content, $imageContainer, $focusContainer);
};

module.exports.onContentPluginBuild = function(object) {
    let content = object.content;
    let $toolbar = object.$toolbar;
    let $options = $toolbar.find('.more-options');
    let $btnUploadTpl;
    let $btnFocusTpl;
    let forbiddenPlugins;
    let $btnUpload = $toolbar.find('.cloud-image-upload');
    let $btnResize = $toolbar.find('.cloud-image-rsz');


    if (content.getProperties('is_image')) {
        if (content.$.find('.cloud-placeholder').length) {
            return;
        }

        forbiddenPlugins = content.getForbiddenPlugins();
        if (!forbiddenPlugins.find((index) => index === 'upload')) {
            $btnUploadTpl = jQuery(btnUploadTpl());
            if ($btnUpload.length == 0) {
                $options.append($btnUploadTpl);
            }

            $btnUploadTpl.on('click', function() {
                pluginUploader.onClick(content);
            });
        }

        if (!forbiddenPlugins.find((index) => index === 'focus')) {
            $btnFocusTpl = jQuery(btnFocusTpl());
            if ($btnResize.length == 0) {
                $options.append($btnFocusTpl);
            }
            $btnFocusTpl.on('click', function() {
                showForm(content);
            });
        }
    }
};

module.exports.onContentHover = function(object) {
    let content = object.content;
    let $toolbar = object.$toolbar;
    let $btnResizeTpl = jQuery(btnResizeTpl());
    let forbiddenPlugins = content.getForbiddenPlugins();

    if (content.getProperties('is_image')) {
        if (!forbiddenPlugins.find((index) => index === 'resize')) {
            $toolbar.append($btnResizeTpl);
            $btnResizeTpl.on('mousedown.resize', {'content': content}, startResize);
        }
    }

    positionBtn(content.$);
};

module.exports.beforePopinOpen = function(config) {
  if (config.$popin.dialog('option', 'classes.ui-dialog').includes('image-settings-popin')) {
        config.blur = false;
    }
};
